import { TemplateResult } from 'lit-element';
import { defaultTemplateProcessor } from 'lit-html/lib/default-template-processor';

/**
 * An overridden lit-html template tag which returns html with whitespace
 * trimmed from the start and end. Useful for those rare cases where the
 * whitespace matters with inline elements.
 */
export const trimmedHtml = (
  strings: TemplateStringsArray,
  ...values: unknown[]
) =>
  new TrimmedTemplateResult(strings, values, 'html', defaultTemplateProcessor);

class TrimmedTemplateResult extends TemplateResult {
  getHTML(): string {
    return super.getHTML().trim();
  }
}
